import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

/**
 * TODO: Ojo, solo esta cogiendo los meses del año actual
 * */
// High season ranges without holy week
export const highSeasonRanges = [
    moment.range(moment().month(0).date(1).startOf('day'), moment().month(0).date(31).startOf('day')),
    moment.range(moment().month(5).date(1).startOf('day'), moment().month(6).date(31).startOf('day')),
    moment.range(moment().month(11).date(1).startOf('day'), moment().month(11).date(31).startOf('day'))
];


// WEBPACK FOOTER //
// ./src/config/highSeasonRanges.js